<template>
  <div class="scrollable-div display-scrollbar" ref="scrollContainer" @scroll="handleScroll">
    <table class="full-width-table">
      <tbody>
        <tr class="table-header">
          <th style="width: 12%">Date/Time</th>
          <th style="width: 12%">User</th>
          <th style="width: 15%">Action</th>
          <th style="width: 15%">Name of Affected Record</th>
          <th style="">Diary Note</th>
        </tr>
        <tr v-for="log in logs.slice(0, maxLogs)">
          <td>
            <span>{{ formatDate(log.CREATEDATE) }}</span>
          </td>
          <td>
            <span>{{ `${log.user?.FIRSTNAME || ''} ${log.user?.LASTNAME || ''}`.trim() }}</span>
          </td>
          <td>
            <span>{{ log.ACTION }}</span>
          </td>
          <td>
            <span class="navigate-to-company" @click="navigate(log)">{{ formatName(log) }}</span>
          </td>
          <td style="overflow: hidden; text-wrap: nowrap; text-overflow: ellipsis">
            <span>{{ log.DIARYTYPE }} - {{ log.DIARYTEXT }}</span>
          </td>
        </tr>
        <tr v-if="loading" class="loading-row">
          <td colspan="5"><img src="../../assets/spinner.svg" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import useLogsQuery from '@/composables/useLogsQuery';
import useDecryptSymbols from '@/composables/useDecryptSymbols';
import { onMounted, ref, watch, computed } from 'vue';

export default {
  name: 'Logs',
  props: {
    since: String,
    type: String,
    user: String,
  },
  setup(props) {
    const { decryptSymbols } = useDecryptSymbols();
    const { getLogs } = useLogsQuery();
    const queryResult = ref(null);
    const loading = ref(false);

    const fetchLogs = async () => {
      const { result, loading: logsLoading } = getLogs(props.since, props.type, props.user);
      queryResult.value = result;
      loading.value = logsLoading;
    };

    const logs = computed(() => {
      return queryResult.value?.value?.logs.map((log) => decryptSymbols(log)) || [];
    });

    onMounted(() => {
      fetchLogs();
    });

    watch(
      () => [props.since, props.type, props.user],
      ([newSince, newType, newUser]) => {
        fetchLogs();
      }
    );

    return {
      logs,
      loading,
    };
  },
  data() {
    return {
      maxLogs: 200,
      rowIncrement: 200,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const dateObj = new Date(parseInt(date));
      return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
    },
    navigate(log) {
      if (log.COMPANYID) {
        this.$router.push({ name: 'companies', params: { companyid: log.COMPANYID } });
      } else if (log.CONTACTID) {
        this.$router.push({ name: 'contacts', params: { contactid: log.CONTACTID } });
      }
    },
    formatName(log) {
      if (log.COMPANYID) return log.company?.NAME;
      if (log.CONTACTID) return `${log.contact?.FIRSTNAME || ''} ${log.contact?.LASTNAME || ''}`.trim();
      return log.NAME;
    },
    handleScroll(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // Check if we're near the bottom (within 100px)
      const nearBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (nearBottom && this.maxLogs < this.logs.length && !this.loading) {
        // Load more rows if we haven't displayed all data yet
        this.maxLogs += this.rowIncrement;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navigate-to-company {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
